import React from 'react';

interface SuccessModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    title: string;
    children: React.ReactNode;
    buttonText: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onConfirm, title, children, buttonText }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-50 flex justify-center items-center p-4"
            aria-modal="true"
            role="dialog"
        >
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-2xl p-6 w-full max-w-md text-center animate-fade-in">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 dark:bg-green-900/50 mb-4">
                    <i className="fas fa-check text-2xl text-green-600 dark:text-green-400"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{title}</h2>
                <p className="text-gray-600 dark:text-slate-300 mb-8">{children}</p>
                <div className="flex justify-center">
                    <button
                        onClick={onConfirm}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-8 rounded-lg transition-colors"
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;